import React from 'react';
import BorderHorizontalIcon from '@mui/icons-material/BorderHorizontal';

import { hasTrussDesignPermission } from '@paragon/login-tools';

import { useAppMonitor } from '../../../monitor';
import { toggleShowReferenceLines } from '../../../store/actions/visualOptionActions';
import { getReferenceLineDisplayMode } from '../../../store/selectors/getReferenceLineDisplayMode';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function ReferenceLinesVisibilityButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const inLayoutMode = useAppSelector(isLayoutViewActive);
  const hasPermission = useAppSelector(hasTrussDesignPermission);

  const mode = useAppSelector(getReferenceLineDisplayMode);

  if (inLayoutMode || !hasPermission) return null;

  return (
    <ToolbarIconButton
      disabled={mode.toggle == null}
      toggleValue={mode.type !== 'none'}
      icon={<BorderHorizontalIcon />}
      title={`${mode.type === 'none' ? 'Show' : 'Hide'} Reference Lines (Ctrl + 9)`}
      onClick={() => {
        dispatch(toggleShowReferenceLines());
        monitor.recordInteraction('Reference lines visibility toggled via toolbar button');
      }}
    />
  );
}
